import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon'
import { SvgIconProps } from '@material-ui/core'

/**
 * Figma link: https://www.figma.com/file/3z9SovcAVVWRw6bR0jPFLc/UI_library_2.0?node-id=5890%3A433
 *
 * @param {SvgIconProps} props - svg props
 */
export const CloseLargeIcon = (props: SvgIconProps): JSX.Element => {
    const color = props.color || 'currentColor'
    const svgProps = Object.assign({}, props)
    delete svgProps.color
    return (
        <SvgIcon {...svgProps} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M20.6464 5.16641C20.8417 4.97115 20.8417 4.65457 20.6464 4.4593L19.5407 3.35355C19.3454 3.15829 19.0289 3.15829 18.8336 3.35355L12 10.1871L5.16641 3.35355C4.97115 3.15829 4.65457 3.15829 4.4593 3.35355L3.35355 4.4593C3.15829 4.65457 3.15829 4.97115 3.35355 5.16641L10.1871 12L3.35355 18.8336C3.15829 19.0289 3.15829 19.3454 3.35355 19.5407L4.4593 20.6464C4.65457 20.8417 4.97115 20.8417 5.16641 20.6464L12 13.8129L18.8336 20.6464C19.0289 20.8417 19.3454 20.8417 19.5407 20.6464L20.6464 19.5407C20.8417 19.3454 20.8417 19.0289 20.6464 18.8336L13.8129 12L20.6464 5.16641Z' fill={color}/>
        </SvgIcon>
    )
}

export default CloseLargeIcon
